import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

const rootElement = document.getElementById("root");

const tree = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// react-snap writes prerendered markup into #root at build time. When it's
// present we hydrate it instead of throwing it away and re-rendering, which is
// what keeps the prerendered SEO content on screen (and in the crawler's view).
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, tree);
} else {
  ReactDOM.createRoot(rootElement).render(tree);
}
